export default __webpack_public_path__ + "static/media/arrow-down-1.877f0a85.svg";